import { Container, Item, Number, Text } from './styles'

interface Props {
  items: string[]
}

export const List = ({ items }: Props) => {
  return (
    <Container>
      {items.map((item, index) => (
        <Item key={index}>
          <Number> {index + 1}</Number>
          <Text>{item}</Text>
        </Item>
      ))}
    </Container>
  )
}
